import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ExternalScript } from "@thelabnyc/thelabui/src/components/ExternalScript";

import { CheckoutApp } from "../apps/checkout/CheckoutApp";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as CheckoutHeader } from "./CheckoutHeaderTemplate";
import { Template as MessageBanner } from "./MessageBannerTemplate";

export const Template = (
    props: Immutable<templates.CheckoutDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            showHeader={false}
            wrapMain={false}
        >
            {/* PageSkeleton's flash <Messages> is gated off here
                (showHeader={false}), so render the Django flash queue
                per-message, plus a trailing empty-fallback banner (message="")
                whose MessageBanner surfaces the Redux `payment_error` set on a
                failed payment submission. */}
            {props.page_chrome.messages.map((message, i) => (
                <MessageBanner
                    key={i}
                    tags={message.tags}
                    message={message.text}
                />
            ))}
            <MessageBanner tags="" message="" />
            <CheckoutHeader {...props.checkout_header} />
            {/* CyberSource device fingerprint (fraud-critical) -- the original
                oscar/checkout/_fingerprint.html, ported with server-reversed
                redirect URLs. The device profiling completes long before the
                order is placed. */}
            <p
                style={{
                    background: `url(${props.fingerprint_img_1_url})`,
                }}
            />
            <img src={props.fingerprint_img_2_url} alt="" />
            <ExternalScript
                src={props.fingerprint_js_url}
                type="text/javascript"
                async={true}
            />
            {/* Google Maps Places powers the address-autocomplete inputs, which
                call new google.maps.places.Autocomplete directly (they do not
                lazy-load the SDK). */}
            <ExternalScript
                src={`https://maps.googleapis.com/maps/api/js?key=${props.google_maps_api_key}&libraries=places`}
                type="text/javascript"
                async={true}
            />
            {/* The checkout app lives in the document's React tree (mounted
                client-side by CheckoutApp; the dependency tree is not
                SSR-safe). */}
            <main id="checkout-app">
                <CheckoutApp />
            </main>
        </PageSkeleton>
    );
};
